import {
  ClassStatsItem,
  ClassStatsResponse,
  CustomizedLessonContent,
  CustomLessonContent,
  LessonContent,
  TaughtLessonAssignment,
  TaughtLessonPayload,
  Unbranded,
} from 'src/interfaces/class-stats.types';
import { pipe } from 'src/utils/pipe';

const isCustomized = (
  content: Unbranded<LessonContent>,
): content is Unbranded<CustomizedLessonContent> => {
  const maybeCustomized = content as CustomizedLessonContent;

  return Boolean(maybeCustomized.customContentId);
};

const isCustom = (
  content: Unbranded<LessonContent>,
): content is Unbranded<CustomLessonContent> => {
  const maybeCustom = content as CustomLessonContent;

  return Boolean(
    maybeCustom.customContentId &&
      content.domain === 'Slides Custom Created From Scratch',
  );
};

const normalizeLessonContent = (
  content: Unbranded<LessonContent>,
): LessonContent => {
  if (isCustom(content)) {
    return {
      ...content,
      brand: 'custom',
    };
  }

  if (isCustomized(content)) {
    return {
      ...content,
      brand: 'customized',
    };
  }

  return {
    ...content,
    brand: 'regular',
  };
};

const isTaughtLesson = (data: ClassStatsItem): data is TaughtLessonPayload =>
  (data.additional_data as LessonContent).hasOwnProperty('title');

const filterTaughtLessons = (data: ClassStatsResponse | null) =>
  data && data.filter(isTaughtLesson);

const normalizeTaughtLessons = (
  data: TaughtLessonPayload[] | null,
): TaughtLessonAssignment[] =>
  (data ?? []).map((item) => ({
    type: 'TaughtLessonAssignment',
    createdDatetime: item.created_datetime,
    userBk: item.user_bk,
    classBk: item.class_bk,
    id: item.id,
    content: normalizeLessonContent(item.additional_data),
  }));

export const prepareTaughtLessons = pipe(
  filterTaughtLessons,
  normalizeTaughtLessons,
);
